import { MonthlyLeaderboardList } from "./monthly-leaderboard-list";
import sequence from "../sequence";
import React from "react";

export default class MonthlyLeaderboard extends React.PureComponent {
  constructor(props) {
    super(props);

    const now = new Date();
    const month = now.getMonth() + 1;
    const year = now.getFullYear();

    props.onViewMonthlyLeaderboard(month, year);
    this.onChange = this.onChange.bind(this);
  }

  onChange() {
    var year = parseInt(this.refs.year.value);
    var month = parseInt(this.refs.month.value);

    var { onViewMonthlyLeaderboard } = this.props;
    if (onViewMonthlyLeaderboard) {
      onViewMonthlyLeaderboard(month, year);
    }
  }

  render() {
    let { monthlyWinsLeaders, monthlyWinningsLeaders} = this.props;

    let months = {
      "January": 1,
      "February": 2,
      "March": 3,
      "April": 4,
      "May": 5,
      "June": 6,
      "July": 7,
      "August": 8,
      "September": 9,
      "October": 10,
      "November": 11,
      "December": 12
    };

    const now = new Date();
    const defaultMonth = now.getMonth() + 1;
    const currentYear = now.getFullYear();

    let monthOptions =
      Object.entries(months).map(([key, value]) => {
        return (
          <option key={value} value={value}>
            {key}
          </option>
        );
      });

    var ageOfOldestPerson = 122;

    var yearOptions = sequence(currentYear - ageOfOldestPerson, currentYear + 1).reverse().map(year => (
      <option key={year}>
        {year}
      </option>
    ));

    return (
      <div className="l-main l-row">
        <div className="l-wrapper">
          <div className="l-content">

            <h1 className="text-center">
              Monthly Leaders
            </h1>

            <div className="form--is-horizontal">
              <div className="batch-g">
                <div className="batch-c-md-1-6">
                  <label className="label--inline" htmlFor="month-selector">
                    <span className="label--radio">
                      Month:
                    </span>

                    <select className="form_input form_input--select form--is-horizontal" defaultValue={defaultMonth} name="month-selector" onChange={this.onChange} ref="month">
                      {monthOptions}
                    </select>
                  </label>
                </div>

                <div className="batch-c-md-1-6">
                  <label className="label--inline label--radio" htmlFor="year-selector">
                    <span className="label--radio">
                      Year:
                    </span>

                    <select className="form_input form_input--select form--is-horizontal" defaultValue={currentYear} name="year-selector" onChange={this.onChange} ref="year">
                      {yearOptions}
                    </select>
                  </label>
                </div>
              </div>
            </div>

            <div className="batch-g batch-g--padding batch-g--gutter">
              <div className="batch-c-md-1-2 batch-c-1-1">
                <h2 className="text-center">
                  Wins
                </h2>

                <MonthlyLeaderboardList label="Wins" players={monthlyWinsLeaders} />
              </div>

              <div className="batch-c-md-1-2 batch-c-1-1">
                <h2 className="text-center">
                  Winnings
                </h2>

                <MonthlyLeaderboardList label="Winnings" players={monthlyWinningsLeaders} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
